import { DemoProvider } from '@/contexts/DemoContext';
import DemoOnePager from '@/components/demo/DemoOnePager';

export default function Demo() {
  return (
    <DemoProvider>
      <DemoOnePager />
    </DemoProvider>
  );
}
